import React from 'react';
import FormField from 'components/Form/FormField';

import { required } from 'utils/formValidators';

const SurveyName = () => (
  <FormField
    label="Survey Name"
    name="customSurveyName"
    containerClassName="form-group"
    inputClassName="form-control survey-name"
    placeholder="Ex: Customer Satisfaction Survey"
    validate={required}
  />
);

export default SurveyName;



// WEBPACK FOOTER //
// ./src/components/customSurvey/FormFields/surveyName.js